import { render, staticRenderFns } from "./the-copyright.vue?vue&type=template&id=17ec37c4&"
import script from "./the-copyright.vue?vue&type=script&lang=js&"
export * from "./the-copyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports